import React from 'react';

/**
 * Lazy-load operator audit route only when internal controls are enabled (FR18).
 */
export function maybeRenderOperatorClassificationAuditRoute(): React.ReactNode {
  if (process.env.REACT_APP_ENABLE_INTERNAL_CONTROLS !== 'true') {
    return null;
  }
  // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
  const Page = require('../pages/OperatorClassificationAuditPage').default as React.ComponentType;
  return <Page />;
}
